import axios from '@/libs/api.request';

export const getPayPlatformConfigList = data => {
    return axios.request({
        url: 'api/systemManagement/payPlatformManagement/getPayPlatformConfigList',
        data: data,
        method: 'post'
    });
};

export const savePayPlatformConfig = data => {
    return axios.request({
        url: 'api/systemManagement/payPlatformManagement/savePayPlatformConfig',
        data: data,
        method: 'post'
    });
};


export const getPayPlatformList = data => {
    return axios.request({
        url: 'api/systemManagement/payPlatformManagement/getPayPlatformList',
        data: data,
        method: 'post'
    });
};
